import React, { useState } from "react";
import Modal from "../../utils/customModal";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  cleanIputTextNumber,
  loadingHtml,
  errorContainer,
  encryptPassword
} from "../../utils/functions";
import { validateHardToken } from "../../../Redux/actions/tokenActions";
import { getSessionCountry } from "../../../Redux/reducer/session";
import { getSpk } from "../../../Redux/reducer/env";

const TokenComponent = ({ send, goBack }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [token, setToken] = useState("");
  const [auth, setAuth] = useState(null);
  const country = useSelector((state) => getSessionCountry(state));
  const salt = useSelector((state) => getSpk(state));
  const [modal, setModal] = useState({
    show: false,
    content: null,
    onClose: undefined,
  });

  const handleChange = (event) => {
    var value = cleanIputTextNumber(event.target.type, event.target.value);
    setToken(value);
  };

  const handleChangeAuth = (event) => {
    setAuth(event.target.value);
  };

  const sendToken = () => {
    if (token !== "") {
      setModal({
        ...modal,
        show: true,
        content: loadingHtml(`${t('token.modal.loading')}`),
      });

      var inputAuth = auth;
      if(country == "PA") {
        inputAuth = encryptPassword(inputAuth, salt);
      }

      // Validamos el token ingresado
      return dispatch(validateHardToken({ access: inputAuth, otp: token }))
        .then((response) => {
          if( response.securityCode !== "" ) {
            closeModal();
            send({ validToken: response.securityCode });
          } else {
            var button = {
              continueBtn: { action: () => closeModal(), text: `${t('general.buttons.close')}` },
            };
            setModal({
              show: true,
              content: errorContainer(
                `${t('general.labels.errorTitle')}`,
                `${t('token.modal.invalid')}`,
                button
              ),
              onClose: () => closeModal(),
            });
          }
        })
        .catch((err) => {
          var notificaction = err.response.data.notifications[0];
          var button = {
            continueBtn: { action: () => closeModal(), text: `${t('general.buttons.close')}` },
          };
          setModal({
            show: true,
            content: errorContainer(
              `${t('general.labels.errorTitle')}`,
              notificaction.description,
              button
            ),
            onClose: () => closeModal(),
          });
        });
    } else {
      var button = {
        continueBtn: { action: () => closeModal(), text: `${t('general.buttons.accept')}` },
      };

      setModal({
        ...modal,
        show: true,
        content: errorContainer(`${t('token.modal.requiredTitle')}`, `${t('token.modal.requiredMessage')}`, button)
      })
    }
  };

  const closeModal = () => {
    setModal({ show: false, content: null, onClose: undefined });
  };

  return (
    <div className="token-container">
      <form>
        {country == "PA" && (
          <div className="row-line">
            <label>{t('token.form.password.label')}</label>
            <input
              type="password"
              value={auth}
              onChange={handleChangeAuth}
              placeholder={t('token.form.password.placeholder')}
            />
          </div>
        )}
        <div className="row-line">
          <label>{t('token.form.token.label')}</label>
          <input
            type="text"
            value={token}
            onChange={handleChange}
            placeholder={t('token.form.token.placeholder')}
          />
        </div>
      </form>
      <div className="form-actions clearfix">
        <button className={`button button--pill`} onClick={goBack}>
          {t('general.buttons.cancel')}
        </button>
        <button className={`button button--pill`} onClick={sendToken}>
          {t('general.buttons.confirm')}
        </button>
      </div>
      <Modal show={modal.show} handleClose={modal.onClose}>
        {modal.content}
      </Modal>
    </div>
  );
};

export default TokenComponent;
